
  export enum StorageKeys {
    JwtToken = 'jwtToken',

    CatalogItemRows = 'catalogItemRows'
  }